import { Autocomplete, Chip, TextField } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';

/**
 * Shared Autocomplete for portal selection — used in PortalPicker and MainScreen.
 *
 * Bakes in:
 *   - multiple + disableCloseOnSelect
 *   - Sorted chips (renderTags)
 *   - Checkbox option rows (renderOption)
 *   - Consistent placeholder input (renderInput)
 *   - X and ▼ buttons pinned to top-right, always visible
 *
 * Pass through: options, value, onChange, isOptionEqualToValue, sx (merged), any other Autocomplete prop.
 */

const ADORNMENT_SX = {
    '& .MuiAutocomplete-endAdornment': { top: 8, right: 9 },
    '& .MuiAutocomplete-clearIndicator': { visibility: 'visible', color: 'rgba(0,0,0,0.6)' },
    '& .MuiAutocomplete-popupIndicator': { color: 'rgba(0,0,0,0.6)' },
};

export default function PortalAutocomplete({ sx, ...props }) {
    return (
        <Autocomplete
            multiple
            disableCloseOnSelect
            getOptionLabel={opt => opt?.name ?? ''}
            renderTags={(selected, getTagProps) =>
                [...selected]
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((option, index) => (
                        <Chip
                            {...getTagProps({ index })}
                            key={option.id ?? option.source_name}
                            label={option.name}
                            size="small"
                            color="primary"
                        />
                    ))
            }
            renderOption={(liProps, option, { selected }) => (
                <li {...liProps}>
                    <Checkbox style={{ marginRight: 8 }} checked={selected} />
                    {option.name}
                </li>
            )}
            renderInput={params => (
                <TextField {...params} placeholder="Upiši naziv portala..." />
            )}
            sx={{ ...ADORNMENT_SX, ...sx }}
            {...props}
        />
    );
}
